import React, { useState } from 'react';
import FsLightbox from 'fslightbox-react';


const Video = ({className}) => {

    const [toggler, setToggler] = useState(false);

    return (
        
        <div className="Video-content">

            <button type="button" onClick={ () => setToggler(!toggler) } className="d-flex">
                <i className={className}></i>
            </button>
            <FsLightbox
                toggler={ toggler }
                sources={ [ 'video/aboutVideo.mp4' ] } 
                
            />
        </div>
    );
};

export default Video;